import { useCallback,useEffect,useRef,useState } from 'react';
import { api,errorText,queryString } from './api';
import type { Pagination } from '../types';

export function useResource<T>(path:string,filters:Record<string,string|number|undefined>={}){
  const [data,setData]=useState<T[]>([]);const [meta,setMeta]=useState<Pagination>({current_page:1,last_page:1,per_page:25,total:0});const [loading,setLoading]=useState(true);const [error,setError]=useState('');
  const mounted=useRef(true);
  const stable=JSON.stringify(filters);
  useEffect(()=>{mounted.current=true;return()=>{mounted.current=false;};},[]);
  const load=useCallback(async(page=meta.current_page||1)=>{if(mounted.current){setLoading(true);setError('');}try{const r=await api.get<T[]>(`${path}${queryString({...filters,page})}`);if(mounted.current){setData(r.data);if(r.meta)setMeta(r.meta);}}catch(e){if(mounted.current)setError(errorText(e));}finally{if(mounted.current)setLoading(false);}},[path,stable]);
  useEffect(()=>{void load(1);},[load]);
  return {data,meta,loading,error,reload:load,setData};
}

export function useSummary<T extends Record<string,string|number>>(path:string,filters:Record<string,string|number|undefined>={}){
  const [data,setData]=useState<T|null>(null);const [loading,setLoading]=useState(true);const [error,setError]=useState('');
  const mounted=useRef(true);
  const stable=JSON.stringify(filters);
  useEffect(()=>{mounted.current=true;return()=>{mounted.current=false;};},[]);
  const load=useCallback(async()=>{if(mounted.current){setLoading(true);setError('');}try{const r=await api.get<T>(`${path}${queryString(filters)}`);if(mounted.current)setData(r.data);}catch(e){if(mounted.current)setError(errorText(e));}finally{if(mounted.current)setLoading(false);}},[path,stable]);
  useEffect(()=>{void load();},[load]);
  return {data,loading,error,reload:load};
}
